import { render, staticRenderFns } from "./DownloadCourseEffectListModal.vue?vue&type=template&id=79087065&"
import script from "./DownloadCourseEffectListModal.vue?vue&type=script&lang=js&"
export * from "./DownloadCourseEffectListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports